// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 43 ? "LoginComponent" : chunkId) + "." + {"43":"639454c4","239":"56e6da81"}[chunkId] + ".chunk.js";
};